<template>
    <div class="allocation-table">
        <div class="top-message">
            <div>同收货人&目的地址的相关任务</div>
            <div class="total-message">
                <span>已选 {{ selectData.length }} 单</span>
                <span class="total-volume">总方量(m³): {{ totalVolume }}</span>
            </div>
        </div>
        <m-pane
        ref="tablePage"
        :config="config"
        :totalData="totalData"
        :pageTotal="pageTotal"
        :loading="loading"
        @pageChange="pageChange"
        @sizeChange="sizeChange"
        @selectChange="selectChange"
        >
        </m-pane>
    </div>

</template>
<script>
import mPane from '@/components/otpPanel';
import config from './config.js';
import { getAssignQueryApi } from '../../../../../../api/appointmentCenter';
import { mapState } from 'vuex';

export default {
    components: { mPane },
    props: {
        taskDataList: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            config: config,
            totalData: [],
            loading: false,
            pageTotal: 0,
            searchParams: {
                pageSize: config.page.pageSize,
                pageNo: 1,
                taskNoList: []
            },
            selectData: []
        };
    },
    computed: {
          ...mapState({
            supplier: state => state.supplier,
        }),
        totalVolume: function() {
            return this.selectData.reduce((total, num) => {
                return Math.round((+total + (+num.totalVolume)) * 1000000) / 1000000;
            }, 0);
        }
    },
    methods: {
        getList () {
            this.loading = true;
            this.searchParams = {
                ...this.searchParams,
                carrierVisibleFlag: 'Y',
                carrierCode: this.supplier.supplierCode
            }
            getAssignQueryApi(this.searchParams).then(res => {
                if (res && +res.code === 0) {
                    this.totalData = res.data.list || [];
                    this.totalData.forEach(item => {
                        this.totalData.forEach(item => {
                            if (!this.selectData.map(v => v.taskNo).includes(item.taskNo)) {
                                this.$refs.tablePage.$refs.table.$refs.moduleTable.toggleRowSelection(item, true);
                            }
                        });
                    });
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        handleOk () {
            if (!this.selectData.length) return this.$message.warning('请先勾选数据');
        },
        selectChange(data) {
            this.selectData = data;
        },
        pageChange (data) {
            // 分页器页数变化
            this.searchParams.pageNo = data;
            this.getList();
        },
        sizeChange (data) {
            // 分页器页数大小变化
            this.searchParams.pageSize = data;
            this.searchParams.pageNo = 1;
            this.getList();
        }
    },
    mounted () {
        const filterData = this.taskDataList.filter(item => (!['999', '998', '880'].includes(item.taskStatus)));
        this.searchParams.taskNoList = filterData.map(i => i.taskNo);
        this.getList();
    }
};
</script>
<style lang="less">
.allocation-table {
    .mPane3-back-up {
        .el-table {
            min-height: calc(~ '100vh - 300px') !important;
            max-height: calc(~ '100vh - 300px') !important;
        }
        .model-table-search{
            display: none;
        }
    }
    .top-message{
        font-size: 14px;
        margin-left: 10px;
        .total-message{
            margin-top: 10px;
            margin-bottom: 2px;
            font-size: 12px;
        }
        .total-volume{
            margin-left: 30px;
        }
    }
}
</style>
